<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'dialog_justificative_title' | translate }}</h2>

  <mat-tab-group #tabGroup animationDuration="0ms">
    <mat-tab [label]="'dialog_justificative_tab_new' | translate">
      <mat-dialog-content [formGroup]="form" class="tab-content">
        <p>{{ 'dialog_justificative_new_instructions' | translate }}</p>

        <mat-form-field appearance="fill">
          <mat-label>{{ 'dialog_justificative_field_data' | translate }}</mat-label>
          <mat-select formControlName="justificationTypes" multiple>
            <mat-option *ngFor="let option of justificationOptions" [value]="option">{{ option | translate }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('justificationTypes')?.hasError('required')">{{ 'dialog_justificative_error_type' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ 'dialog_justificative_field_comment' | translate }}</mat-label>
          <textarea matInput formControlName="comment" rows="3"></textarea>
        </mat-form-field>

        <div class="dropzone" [class.dragging]="isDragging" (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <input type="file" #fileInput hidden (change)="onFileSelected($event)" accept=".jpeg,.jpg,.png,.doc,.docx,.csv,.pdf,.xls,.xlsx" />
          <mat-icon>cloud_upload</mat-icon>
          <span>{{ 'dialog_justificative_dropzone' | translate }}</span>
        </div>

        <div *ngIf="fileName && fileUrl" class="file-preview">
          <a [href]="fileUrl" target="_blank" class="file-link" [matTooltip]="'dialog_justificative_tooltip_open' | translate">
            <mat-icon>description</mat-icon>
            <span class="file-name">{{ fileName }}</span>
          </a>
          <button mat-icon-button color="warn" (click)="removeFile()" [matTooltip]="'dialog_justificative_tooltip_remove' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-dialog-content>
    </mat-tab>

    <mat-tab [label]="'dialog_justificative_tab_existing' | translate">
      <mat-dialog-content class="tab-content">
        <p>{{ 'dialog_justificative_existing_instructions' | translate }}</p>

        <mat-form-field appearance="fill">
          <mat-label>{{ 'dialog_justificative_field_existing' | translate }}</mat-label>
          <mat-select [formControl]="selectedJustificativeControl">
            <mat-option *ngFor="let justif of uniqueProofs" [value]="justif"> {{ justif.fileName }} - ({{ justif.comment }}) </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
    </mat-tab>
  </mat-tab-group>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ 'common_btn_cancel' | translate }}</button>
    <button mat-flat-button color="accent" [disabled]="isSaveDisabled()" (click)="onSave()">{{ 'common_btn_add' | translate }}</button>
  </mat-dialog-actions>
</div>
